import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PageHero } from "../components/site/PageHero";
import { SectionLabel } from "../components/site/SectionLabel";
import { CTASection } from "../components/site/CTASection";
import { ADVISORY, ADVISORY_HERO } from "../data/advisory";
import { ADVISORY_ICONS, ENGAGEMENTS } from "../data/site";

export default function AdvisoryOverview() {
  return (
    <div>
      <PageHero
        variant="dark"
        label="Advisory"
        title={ADVISORY_HERO.title}
        intro={ADVISORY_HERO.intro}
        crumbs={[{ label: "Advisory" }]}
      />

      <section className="border-b border-brand-line bg-white">
        <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
          <SectionLabel>Core advisory areas</SectionLabel>
          <div className="mt-8 grid gap-px border border-brand-line bg-brand-line md:grid-cols-2">
            {ADVISORY.map((a) => {
              const Icon = ADVISORY_ICONS[a.icon];
              return (
                <Link
                  key={a.slug}
                  to={`/advisory/${a.slug}`}
                  data-testid={`advisory-item-${a.slug}`}
                  className="group flex flex-col bg-white p-8 transition-colors hover:bg-brand-blue/[0.03]"
                >
                  <div className="flex items-center gap-3">
                    {Icon && <Icon className="h-7 w-7 text-brand-red" strokeWidth={1.5} />}
                    <h2 className="font-heading text-xl font-bold text-brand-ink group-hover:text-brand-blue">
                      {a.title}
                    </h2>
                  </div>
                  <p className="mt-4 flex-1 text-[15px] leading-relaxed text-brand-muted">{a.short}</p>
                  <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-brand-blue">
                    Explore <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                  </span>
                </Link>
              );
            })}
          </div>
        </div>
      </section>

      <section className="border-b border-brand-line">
        <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
          <SectionLabel>How MATRIVON works</SectionLabel>
          <h2 className="max-w-2xl font-heading text-3xl font-bold tracking-tight text-brand-ink lg:text-4xl">
            The engagement depends on the decision.
          </h2>
          <p className="mt-4 max-w-2xl text-brand-muted">
            Not every business problem requires a long consulting project. Fees are agreed per
            engagement based on scope.
          </p>
          <div className="mt-10 grid gap-px border border-brand-line bg-brand-line md:grid-cols-3">
            {ENGAGEMENTS.map((e) => (
              <div key={e.title} className="bg-white p-8">
                <e.icon className="h-7 w-7 text-brand-blue" strokeWidth={1.5} />
                <h3 className="mt-5 font-heading text-lg font-bold text-brand-ink">{e.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-brand-muted">{e.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTASection secondary={{ to: "/expertise", label: "See Industrial Expertise" }} />
    </div>
  );
}
